import { useGlobalContext } from "../../../../Context/Context";
import React, { useEffect, useState, useRef } from "react";
import Button from "../../../Custom/Button/Button";
import sortImg from "../../../../picture/Sort.png";
import redniBrojeviImg from "../../../../picture/redniBrojevi.png";
import reorderImg from "../../../../picture/reorder.png";
import arrowImg from "../../../../picture/NextLanguage.png";
import editImg from "../../../picture/olovka.png";
import DokumentaZaposlenogVazeca from "./DokumentaZaposlenogVazeca";
import DokumentaZaposlenogArhivirana from "./DokumentaZaposlenogArhivirana";
import arrowLeftImg from "../../../../picture/arrowLeft.png";

const styles = {
  cell: { paddingTop: "5px", textAlign: "center", fontWeight: "bold" },
  smallCell: { width: "30px", textAlign: "center", height: "5vh" },
  actionCell: {
    width: "45px",
    minWidth: "45px",
    maxWidth: "45px",
    height: "45px",
    textAlign: "center",
    verticalAlign: "middle"
  },
  statusSquare: { width: "22px", height: "22px", margin: "0 auto" }
};

function TabelaZaposleni({
  data,
  setZaposlenId,
  selectedRows,
  setSelectedRows,
  editDataZaposlen,
  setEditDataZaposlen
}) {
  const [zaposleni, setZaposleni] = useState([]);
  const [isCheckedRedniBrojevi, setIsCheckedRedniBrojevi] = useState(false);
  const [isCheckedSort, setIsCheckedSort] = useState(false);
  const [columns, setColumns] = useState([
    "ime",
    "prezime",
    "radnoMesto",
    "lokacija"
  ]);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [vazecaDokumenta, setVazecaDokumenta] = useState([]);
  const [arhiviranaDokumenta, setArhiviranaDokumenta] = useState([]);
  const [isSortRadnoMesto, setIsSortRadnoMesto] = useState(false);

  const [localStatusi, setLocalStatusi] = useState({});

  const { dictionary, setEditZaposlenData, apiKey, loggedUser, baseUrl } =
    useGlobalContext();

  const checkedRows = selectedRows || [];
  const isCheckedAll =
    zaposleni.length > 0 && checkedRows.length === zaposleni.length;

  useEffect(() => {
    if (data) setZaposleni(data);
  }, [data]);

  useEffect(() => {
    setExpandedRowId(editDataZaposlen ? editDataZaposlen.id : null);
  }, [editDataZaposlen]);

  useEffect(() => {
    if (expandedRowId) fetchDokumenta(expandedRowId);
  }, [expandedRowId]);

  const fetchDokumenta = async (id) => {
    const response = await fetch(
      `https://data.nadzor.app/api/zaposleni/readDocs.php?employee_id=${id}`
    );
    const resData = await response.json();
    if (resData.status === 200) {
      setVazecaDokumenta(resData.vazeca);
      setArhiviranaDokumenta(resData.arhivirana);
      setExpandedRowId(id);
    }
  };

  const handleRowClick = async (id) => {
    if (expandedRowId === id) {
      setExpandedRowId(null);
      setVazecaDokumenta([]);
      setArhiviranaDokumenta([]);
    } else {
      setExpandedRowId(id);
    }
  };

  const moveToArhivirani = async (dokument) => {
    try {
      const res = await fetch(
        "https://data.nadzor.app/api/zaposleni/documentStatus.php",
        {
          method: "POST",
          body: JSON.stringify({
            doc_id: dokument.id,
            novi_status: "ARHIVIRAN",
            api_key: apiKey,
            user_id: loggedUser.id
          })
        }
      );
      const resData = await res.json();
      if (resData.status === 200) {
        setArhiviranaDokumenta((prev) => [
          ...prev,
          { ...dokument, status_dokumenta: "ARHIVIRAN" }
        ]);
        setVazecaDokumenta((prev) => prev.filter((d) => d.id !== dokument.id));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const moveToVazeci = async (dokument) => {
    try {
      const res = await fetch(
        "https://data.nadzor.app/api/zaposleni/documentStatus.php",
        {
          method: "POST",
          body: JSON.stringify({
            doc_id: dokument.id,
            novi_status: "VAZECI",
            api_key: apiKey,
            user_id: loggedUser.id
          })
        }
      );
      const resData = await res.json();
      if (resData.status === 200) {
        setVazecaDokumenta((prev) => [
          ...prev,
          { ...dokument, status_dokumenta: "VAZECI" }
        ]);
        setArhiviranaDokumenta((prev) =>
          prev.filter((d) => d.id !== dokument.id)
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleStatusChange = (zaposleniId, noviStatus) => {
    setLocalStatusi((prev) => ({ ...prev, [zaposleniId]: noviStatus }));
  };

  const getOverallDocStatus = (zaposlen) => {
    if (localStatusi[zaposlen.id]) return localStatusi[zaposlen.id];
    return zaposlen.global_status || "empty";
  };

  const getBrojDokumenata = (zaposlen) => zaposlen.broj_dokumenata || 0;

  const handleCheckRedniBrojevi = () =>
    setIsCheckedRedniBrojevi((prev) => !prev);

  const handleCheckSort = () => {
    setIsCheckedSort((prev) => !prev);
    setZaposleni((prev) => [...prev].reverse());
  };

  const handleReorderColumns = (index) => {
    const copy = [...columns];
    const a = copy[index];
    const b = copy[index + 1];
    const isImePrezime = (x) => x === "ime" || x === "prezime";

    if (isImePrezime(a) && isImePrezime(b)) {
      [copy[index], copy[index + 1]] = [copy[index + 1], copy[index]];
      setColumns(copy);
      return;
    }

    const iIme = copy.indexOf("ime");
    const iPrez = copy.indexOf("prezime");

    if (iIme !== -1 && iPrez !== -1) {
      const left = Math.min(iIme, iPrez);
      const right = Math.max(iIme, iPrez);
      if (index === left - 1) {
        const before = copy[left - 1];
        copy.splice(left - 1, 3, copy[left], copy[right], before);
        setColumns(copy);
        return;
      }
      if (index === right) {
        const after = copy[right + 1];
        copy.splice(left, 3, after, copy[left], copy[right]);
        setColumns(copy);
        return;
      }
    }

    [copy[index], copy[index + 1]] = [copy[index + 1], copy[index]];
    setColumns(copy);
  };

  const handleCheckRow = (id, e) => {
    e.stopPropagation();
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };

  const handleCheckAll = () => {
    if (isCheckedAll) setSelectedRows([]);
    else setSelectedRows(zaposleni.map((z) => z.id));
  };

  const handleClickEdit = (zaposlen) => {
    setEditDataZaposlen(zaposlen);
    setEditZaposlenData(zaposlen);
    fetchDokumenta(zaposlen.id);
  };

  const handleSortRadnoMesto = () => {
    setIsSortRadnoMesto((prev) => !prev);
  };

  useEffect(() => {
    if (columns[0] === "radnoMesto") {
      console.log("sortinggg");
      setZaposleni((prev) =>
        [...prev].sort((a, b) =>
          isSortRadnoMesto
            ? b.radnoMesto.localeCompare(a.radnoMesto)
            : a.radnoMesto.localeCompare(b.radnoMesto)
        )
      );
    }
  }, [isSortRadnoMesto, columns]);

  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr
          style={{
            backgroundColor: "#fff",
            position: "sticky",
            top: -25,
            zIndex: 2
          }}
        >
          <th style={{ width: "3%" }}>
            <input
              type="checkbox"
              checked={isCheckedAll}
              onChange={handleCheckAll}
              style={{ width: "30px" }}
            />
          </th>
          <th style={{ width: "6%" }}>
            <div style={{ display: "flex" }}>
              <div onClick={handleCheckSort}>
                <Button active={isCheckedSort}>
                  <img
                    src={sortImg}
                    style={{ width: "30px", height: "30px" }}
                  />
                </Button>
              </div>
              <div onClick={handleCheckRedniBrojevi}>
                <Button active={isCheckedRedniBrojevi}>
                  <img
                    src={redniBrojeviImg}
                    style={{ width: "30px", height: "30px" }}
                  />
                </Button>
              </div>
            </div>
          </th>
          {columns.map((col, index) => (
            <th
              key={index}
              style={{ ...styles.cell, position: "relative", width: "21.5%" }}
            >
              {index === 0 && col === "radnoMesto" && (
                <span
                  onClick={handleSortRadnoMesto}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={arrowLeftImg}
                    style={{
                      width: "20px",
                      marginRight: "5px",
                      transform: isSortRadnoMesto
                        ? "rotate(90deg)"
                        : "rotate(-90deg)"
                    }}
                  />
                </span>
              )}
              {dictionary[col] || col}
              {index < columns.length - 1 && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    right: "-20px",
                    width: "39px",
                    height: "39px",
                    zIndex: 1
                  }}
                  onClick={() => handleReorderColumns(index)}
                >
                  <Button activation={true}>
                    <img
                      src={reorderImg}
                      style={{ width: "30px", height: "30px" }}
                    />
                  </Button>
                </div>
              )}
            </th>
          ))}
          <th colSpan={3}></th>
        </tr>
      </thead>
      <tbody>
        {zaposleni.map((zaposlen, index) => (
          <React.Fragment key={zaposlen.id}>
            <tr
              style={{
                borderBottom: "1px solid #ddd",
                cursor: "pointer",
                backgroundColor:
                  expandedRowId === zaposlen.id ? "#f5f5f5" : "transparent"
              }}
            >
              <td style={styles.cell} onClick={(e) => e.stopPropagation()}>
                <input
                  type="checkbox"
                  checked={checkedRows.includes(zaposlen.id)}
                  onChange={(e) => handleCheckRow(zaposlen.id, e)}
                  style={{ width: "30px" }}
                />
              </td>
              <td
                style={{
                  padding: "5px",
                  textAlign: "start",
                  fontWeight: "bold"
                }}
              >
                {`${isCheckedRedniBrojevi ? zaposlen.redniBroj || index + 1 : index + 1}.`}
              </td>

              {columns.map((col, i) => (
                <td style={{ ...styles.cell, textAlign: "left" }} key={i}>
                  <span style={{ marginLeft: "5px" }}></span>
                  {zaposlen[col]}
                </td>
              ))}

              <td
                onClick={() => handleClickEdit(zaposlen)}
                style={styles.actionCell}
              >
                <img src={editImg} style={{ width: "30px" }} />
              </td>

              <td style={styles.actionCell}>
                {(() => {
                  const status = getOverallDocStatus(zaposlen);
                  if (status === "empty") return null;
                  const bg =
                    status === "correct"
                      ? "#00b055ff"
                      : status === "notif"
                        ? "#f1c40f"
                        : "#ff0000ff";
                  return (
                    <div
                      style={{ ...styles.statusSquare, backgroundColor: bg }}
                    />
                  );
                })()}
              </td>

              <td
                style={{ ...styles.actionCell, cursor: "pointer", padding: 0 }}
              >
                <div
                  onClick={() => handleRowClick(zaposlen.id)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "45px",
                    gap: "2px"
                  }}
                >
                  <div
                    style={{
                      fontSize: "15px",
                      fontWeight: "bold",
                      lineHeight: "12px"
                    }}
                  >
                    {getBrojDokumenata(zaposlen)}
                  </div>
                  <img
                    src={arrowImg}
                    style={{
                      width: "10px",
                      transform:
                        expandedRowId === zaposlen.id
                          ? "rotate(270deg)"
                          : "rotate(90deg)",
                      transition: "transform 0.3s ease"
                    }}
                  />
                </div>
              </td>
            </tr>

            {expandedRowId === zaposlen.id && (
              <tr key={`expanded-${zaposlen.id}`} style={{ zIndex: 0 }}>
                <td
                  colSpan={columns.length + 5}
                  style={{ backgroundColor: "#fafafa", verticalAlign: "top" }}
                >
                  <div style={{ padding: "10px" }}>
                    {/* OVDE SE PRIKAZUJU DOKUMENTA - VRSTA I NAZIV SE DODAJU UNUTAR OVE KOMPONENTE */}
                    <DokumentaZaposlenogVazeca
                      dokumenta={vazecaDokumenta}
                      moveToArhiviraniDoc={moveToArhivirani}
                      onStatusChange={(noviStatus) =>
                        handleStatusChange(zaposlen.id, noviStatus)
                      }
                    />
                    <div>
                      <DokumentaZaposlenogArhivirana
                        dokumenta={arhiviranaDokumenta}
                        setDokumenta={setArhiviranaDokumenta}
                        moveToVazeci={moveToVazeci}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
}

export default TabelaZaposleni;
